
export default {
  name: 'SectionTitleWithText',
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    headingStyle: {
      type: String,
      default: 'fc-heading-1',
    },
  },
};
